import * as React from "react";
import type { SVGProps } from "react";
const SvgDeleteAccount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#delete-account_svg__a)">
      <path d="M12 22a10 10 0 1 1 9.94-8.89 1.006 1.006 0 1 1-2-.22q.052-.443.06-.89a8 8 0 1 0-6.22 7.8 1 1 0 1 1 .44 1.95A9.7 9.7 0 0 1 12 22" />
      <path d="M5.84 19a1 1 0 0 1-1-1c0-2.18 2.05-4 4.56-4H14a1 1 0 0 1 0 2H9.4a2.33 2.33 0 0 0-2.56 2 1 1 0 0 1-1 1M12.5 13.25A3.43 3.43 0 0 1 9.1 10L9 8.29a3.47 3.47 0 0 1 3.43-3.54h.14A3.46 3.46 0 0 1 16 8.24L15.9 10a3.43 3.43 0 0 1-3.4 3.25m-.07-6.5A1.46 1.46 0 0 0 11 8.24l.09 1.63a1.41 1.41 0 1 0 2.82 0L14 8.18a1.45 1.45 0 0 0-1.43-1.43zM17 21a1 1 0 0 1-.71-1.71l4-4a1.004 1.004 0 1 1 1.42 1.42l-4 4A1 1 0 0 1 17 21" />
      <path d="M21 21a1 1 0 0 1-.71-.29l-4-4a1.004 1.004 0 1 1 1.42-1.42l4 4A.999.999 0 0 1 21 21" />
    </g>
    <defs>
      <clipPath id="delete-account_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDeleteAccount;
